import FinishStep from './FinishStep';
import UploadStep from './UploadStep';
import ValidationStep from './ValidationStep';

export default {
  title: 'Følgere',
  steps: {
    upload: 'Upload',
    validate: 'Bekræft',
    finish: 'Færdig',
  },
  labels: {
    import: 'Import',
  },

  FinishStep,
  UploadStep,
  ValidationStep,
};
